import React from "react";
import PropTypes from "prop-types";

const AnalysisTableIcon = ({ icon }) => <span className={`icon-${icon}`} />;

AnalysisTableIcon.propTypes = {
  icon: PropTypes.string
};

export default AnalysisTableIcon;
